
export default {
  name: 'DeviceSelectDialog',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    beforeClose: {
      type: Function,
      default: null,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    fetchGroups: {
      type: Function,
      required: true,
    },
    fetchDevices: {
      type: Function,
      default: null,
    },
    initialOnlineState: {
      type: String,
      default: '0',
    },
    initialClientName: {
      type: String,
      default: '',
    },
    initialGroupParentId: {
      type: [String, Number],
      default: 1,
    },
  },
  data() {
    return {
      innerVisible: false,
      groups: [],
      selectedIndex: 0,
      groupParentId: 1,
      onlineState: '0',
      clientName: '',

      terminalSelect: [],
      isCheckAll: false,
      isIndeterminate: false,

      allDataList: [],
      data_m: [],
      pageNo: 1,
      loading: false,
      finished: false,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.innerVisible = v
        if (v) {
          this.init()
        }
      },
    },
    innerVisible(v) {
      this.$emit('input', v)
    },
  },
  methods: {
    async init() {
      this.onlineState = this.initialOnlineState
      this.clientName = this.initialClientName
      this.groupParentId = this.initialGroupParentId
      this.selectedIndex = 0
      this.resetSelection()

      await this.loadGroupsOnce(true)
      await this.reloadDevices()
    },

    resetSelection() {
      this.terminalSelect = []
      this.isCheckAll = false
      this.isIndeterminate = false
    },

    async loadGroupsOnce(resetGroupToFirst) {
      const groups = await this.fetchGroups({
        onlineState: this.onlineState,
        clientName: this.clientName,
        groupParentId: this.groupParentId,
      })
      this.groups = Array.isArray(groups) ? groups : []

      if (resetGroupToFirst) {
        this.selectedIndex = 0
        if (this.groups.length > 0 && this.groups[0] && this.groups[0].id != null) {
          this.groupParentId = this.groups[0].id
        }
      }
    },

    async reloadDevices() {
      this.pageNo = 1
      this.loading = true
      this.finished = false

      let list = []
      if (this.fetchDevices) {
        list = await this.fetchDevices({
          onlineState: this.onlineState,
          clientName: this.clientName,
          groupParentId: this.groupParentId,
        })
      } else {
        const group = this.groups[this.selectedIndex]
        list = group && Array.isArray(group.children) ? group.children : []
      }

      this.allDataList = Array.isArray(list) ? list : []
      this.data_m = this.allDataList.slice(0, this.pageSize)
      this.finished = this.data_m.length >= this.allDataList.length
      this.loading = false

      this.$nextTick(() => {
        const el = this.$refs.scrollContainer
        if (el) {
          el.scrollTop = 0
        }
      })
    },

    loadDeviceList(index, groupParentId) {
      this.selectedIndex = index
      this.groupParentId = groupParentId
      this.resetSelection()
      this.reloadDevices()
    },

    onSearch() {
      this.resetSelection()
      this.reloadDevices()
    },

    onLoad() {
      if (this.finished) {
        this.loading = false
        return
      }

      const nextPageNo = this.pageNo + 1
      const end = nextPageNo * this.pageSize
      this.data_m = this.allDataList.slice(0, end)
      this.pageNo = nextPageNo
      this.loading = false
      this.finished = this.data_m.length >= this.allDataList.length
    },

    checkAllChange() {
      if (this.isCheckAll) {
        this.terminalSelect = this.allDataList.map(item => `${item.clNo}-${item.clId}`)
      } else {
        this.terminalSelect = []
      }
      this.updateIndeterminateState()
    },

    checkedResultChange() {
      this.updateIndeterminateState()
    },

    updateIndeterminateState() {
      const total = this.allDataList.length
      const checkedCount = this.terminalSelect.length
      if (total === 0) {
        this.isCheckAll = false
        this.isIndeterminate = false
        return
      }
      this.isCheckAll = checkedCount === total
      this.isIndeterminate = checkedCount > 0 && checkedCount < total
    },

    toggleCheckbox(item) {
      const name = `${item.clNo}-${item.clId}`
      const index = this.terminalSelect.indexOf(name)
      if (index > -1) {
        this.terminalSelect.splice(index, 1)
      } else {
        this.terminalSelect.push(name)
      }
      this.updateIndeterminateState()
    },

    isChecked(item) {
      const name = `${item.clNo}-${item.clId}`
      return this.terminalSelect.includes(name)
    },

    truncatedName(fullName) {
      const namePart = fullName.split(' (')[0]
      const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : ''
      if (namePart.length <= 4) {
        return fullName
      } else {
        return `${namePart.substring(0, 4)}...${infoPart}`
      }
    },

    handleConfirm() {
      if (this.terminalSelect.length === 0) {
        this.$emit('confirm-empty')
        return
      }
      const selectedDevices = this.allDataList.filter(item => this.terminalSelect.includes(`${item.clNo}-${item.clId}`))
      this.$emit('confirm', {
        terminalSelect: [...this.terminalSelect],
        selectedDevices,
        onlineState: this.onlineState,
        clientName: this.clientName,
        groupParentId: this.groupParentId,
      })
    },

    handleCancel() {
      this.resetSelection()
      this.$emit('cancel')
    },
  },
}
